import { Routes } from '@angular/router';
import { authGuard, nonAgentGuard, agentGuard } from '@app/core/auth';


export const routes: Routes = [
    { path: '', redirectTo: '/catalog', pathMatch: 'full' },
    { path: 'admin-orders',
        loadComponent: () => import('./features/orders/pages/admin-orders.component').then(m => m.AdminOrdersComponent),
         canActivate: [authGuard, nonAgentGuard]
    },
    { path: 'demande', redirectTo: '/catalog' },
    { path: 'catalog',
        loadComponent: () => import('./features/catalog/pages/demande.component').then(m => m.CatalogComponent),
         canActivate: [authGuard]
    },
    { path: 'product-create',
        loadComponent: () => import('./features/products/pages/product-create.component').then(m => m.ProductCreateComponent),
         canActivate: [authGuard, nonAgentGuard]
    },
    { path: 'product-suggestions',
        loadComponent: () => import('./pages/product-suggestions/product-suggestions.component').then(m => m.ProductSuggestionsComponent),
         canActivate: [authGuard]
    },

    { path: 'unauthorized',
        loadComponent: () => import('./pages/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
    },

    { path: '404',
        loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
    },

    // Wildcard route - must be last
    { path: '**',
        loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent)
    },
];
